'use client'

import { navIconMap } from '@/components/ui/icon-map'
import { cn } from '@/lib/utils/utils'
import Link from 'next/link'
import { usePathname } from 'next/navigation'
import { useState } from 'react'
import { MdKeyboardArrowDown } from 'react-icons/md'
import { getLocalizedUri, I18nValue, LangCode, useI18nValue } from '../i18n/lang-context'
import { NavItem } from '../layout/nav-item'
import { Button } from '../ui/button'
import { Flex, FlexCol } from '../ui/flex'

export function SubMenu({ title, navItems, langCode }: { title: string, navItems: NavItem[], langCode: LangCode }) {

  const [expanded, setExpanded] = useState(false)

  const i18nValue = useI18nValue()

  const pathname = usePathname()

  const getTitle = (title: string | I18nValue) => !title || typeof title === 'string' ? title : i18nValue(title, langCode)

  return (
    <div className='relative select-none' onClick={() => setExpanded(exp => !exp)}>
      <Flex className='cursor-pointer items-center gap-0 text-sm transition-all'>
        <Button variant={'link'} className={cn('text-[14px] font-medium text-foreground opacity-75')}>
          {title}
          <div id='ARROW' className='text-lg font-semibold opacity-70'>
            <MdKeyboardArrowDown size={16} className={cn('transition-all', expanded ? 'rotate-180' : '')} />
          </div>
        </Button>
      </Flex>
      {expanded && <div className='fixed left-0 top-0 z-10 h-[100vh] w-[100vw] bg-transparent'/>}
      <FlexCol className={cn(
        'absolute left-0 top-full z-20 mt-2 min-w-[200px] origin-top items-start gap-2 overflow-hidden rounded-md bg-background p-2 text-sm shadow-sm transition-all dark:shadow-header',
        expanded ? 'scale-y-100' : 'scale-y-0'
      )}>
        {navItems.map((item: NavItem, index: number) => item.href && (
          <Link key={`_${index}`}
                href={getLocalizedUri(item.href, langCode)}
                onClick={() => {if(item.scrollBefore) window.scrollTo(0, 0)}}
                className='flex items-center'>
            <Button variant='link'
              className={cn(
                'flex w-full items-center justify-start gap-2 px-2 py-1 text-left text-[14px] font-medium transition-all',
                pathname === getLocalizedUri(item.href, langCode)
                  ? ' bg-accent/10 rounded-md font-bold'
                  : 'text-foreground opacity-75'
              )}
            >
              {item.iconName && navIconMap[item.iconName] && (
                <span className='h-4 w-4 opacity-80'>{navIconMap[item.iconName]}</span>
              )}
              {getTitle(item.title)}
            </Button>
          </Link>
        ) || item.onClick && (
          <Button key={index} variant={'link'}
                  className={cn('text-[14px] font-medium text-foreground opacity-75')}
                  onClick={() => item.onClick()}>
            {getTitle(item.title)}
          </Button>
      ))}
      </FlexCol>
    </div>
  )
}
